<template>
    <div
        v-if="user !== null"
        class="col-12 col-lg-9 col-xl-6">
        <h2>新規会員登録</h2>
        <div class="card">
            <div class="card-body">
                <user-signup-step state="first_update"/>
                <div class="form-group row">
                    <div class="col-12">
                        <div class="pb-3">
                            <div
                                class="alert alert-info mb-4"
                                style="position: static; width: 100%; transform: none;">
                                下記の項⽬を⼊⼒し、初回ログインを完了してください。
                            </div>

                            <div>
                                <div v-if="$store.state.configs.timezone == 1" class="row">
                                    <div class="col-12">
                                        <div class="mb-3">
                                            <div class="row">
                                                <div class="col-12 col-md-6 col-lg-5">
                                                    <label
                                                        for="timezone"
                                                        class="is-required-ja">
                                                        タイムゾーン設定
                                                    </label>
                                                    <div class="form-group mt-0 mb-1">
                                                        <div class="form-check form-check-inline">
                                                            <input
                                                                v-model="user.is_device_timezone"
                                                                type="checkbox"
                                                                id="is_device_timezone"
                                                                class="form-check-input"
                                                                @change="syncDeviceTimezone">
                                                            <label
                                                                for="is_device_timezone"
                                                                class="mb-0">
                                                                デバイスのタイムゾーンに合わせる
                                                            </label>
                                                        </div>
                                                    </div>
                                                    <select
                                                        v-model="user.timezone"
                                                        id="timezone"
                                                        class="form-control"
                                                        :class="{ 'is-invalid' : errors.timezone }">
                                                        <option value="">選択してください</option>
                                                        <option v-for="timezone in timezones" :value="timezone.key">
                                                            {{ timezone.value }}
                                                        </option>
                                                    </select>
                                                </div>
                                            </div>

                                            <span class="mt-1 small text-muted">日本との時差を自動調節するため、オンライン相談時に滞在している国のタイムゾーンを選択してください。</span>

                                            <div v-if="errors.timezone" class="invalid-feedback d-block">
                                                {{ errors.timezone[0] }}
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div class="row">
                                    <div class="col-12 mb-3">
                                        <label for="birth_year" class="is-required-ja">生年月日</label>
                                        <div class="d-flex align-items-center">
                                            <select
                                                v-model="birth_year"
                                                id="birth_year"
                                                style="max-width: 120px;"
                                                class="form-control"
                                                :class="{ 'is-invalid' : errors.birthday }">
                                                <option :value="null">-</option>
                                                <option v-for="n in rangeYear" :key="n + yearBase" :value="n + yearBase">{{ n + yearBase }}</option>
                                            </select>
                                            <div class="ml-2 mr-2">年</div>

                                            <select
                                                v-model="birth_month"
                                                id="birth_month"
                                                style="max-width: 90px;"
                                                class="form-control"
                                                :class="{ 'is-invalid' : errors.birthday }">
                                                <option :value="null">-</option>
                                                <option v-for="n in 12" :key="n" :value="n">{{ n }}</option>
                                            </select>
                                            <div class="ml-2 mr-2">月</div>

                                            <select
                                                v-model="birth_day"
                                                id="birth_day"
                                                style="max-width: 90px;"
                                                class="form-control"
                                                :class="{ 'is-invalid' : errors.birthday }">
                                                <option :value="null">-</option>
                                                <option v-for="n in rangeDate" :key="n" :value="n">{{ n }}</option>
                                            </select>
                                            <div class="ml-2">日</div>
                                        </div>
                                        <div
                                            v-if="errors.birthday"
                                            class="invalid-feedback d-block">
                                            {{ errors.birthday[0] }}
                                        </div>
                                    </div>

                                    <div class="col-12 mb-3">
                                        <label class="is-required-ja">性別</label>
                                        <div class="form-group mt-2">
                                            <div class="form-check form-check-inline">
                                                <input
                                                    v-model="user.sex"
                                                    type="radio"
                                                    id="male"
                                                    class="form-check-input"
                                                    :class="{ 'is-invalid' : errors.sex }"
                                                    value="0">
                                                <label class="form-check-label" for="male">男</label>
                                            </div>
                                            <div class="form-check form-check-inline">
                                                <input
                                                    v-model="user.sex"
                                                    type="radio"
                                                    id="female"
                                                    class="form-check-input"
                                                    :class="{ 'is-invalid' : errors.sex }"
                                                    value="1">
                                                <label class="form-check-label" for="female">女</label>
                                            </div>
                                            <div
                                                v-if="errors.sex"
                                                class="invalid-feedback d-block">
                                                {{ errors.sex[0] }}
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div class="row">
                                    <div class="col-12 col-md-6">
                                        <div class="mb-3">
                                            <label for="height">身長</label>
                                            <input
                                                v-model="user.height"
                                                type="text"
                                                id="height"
                                                class="form-control"
                                                :class="{ 'is-invalid' : errors.height }"
                                                placeholder="身長">
                                            <div v-if="errors.height" class="invalid-feedback d-block">
                                                {{ errors.height[0] }}
                                            </div>
                                        </div>
                                    </div>

                                    <div class="col-12 col-md-6">
                                        <div class="mb-3">
                                            <label for="weight">体重</label>
                                            <input
                                                v-model="user.weight"
                                                type="text"
                                                id="weight"
                                                class="form-control"
                                                :class="{ 'is-invalid' : errors.weight }"
                                                placeholder="体重">
                                            <div v-if="errors.weight" class="invalid-feedback d-block">
                                                {{ errors.weight[0] }}
                                            </div>
                                        </div>
                                    </div>

                                    <div class="col-12 col-md-6">
                                        <div class="mb-3">
                                            <label for="blood">血液型</label>
                                            <select
                                                v-model="user.blood"
                                                id="blood"
                                                class="form-control"
                                                :class="{ 'is-invalid' : errors.blood }">
                                                <option :value="null">選択してください</option>
                                                <option value="A">A型</option>
                                                <option value="B">B型</option>
                                                <option value="O">O型</option>
                                                <option value="AB">AB型</option>
                                            </select>

                                            <div v-if="errors.blood" class="invalid-feedback d-block">
                                                {{ errors.blood[0] }}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <hr>

                        <div>
                            <h5 class="userAuthHeader">パスワード変更</h5>
                            <div class="row">
                                <div class="col-12">
                                    <div class="mb-3 mb-0-sm">
                                        <label for="current_password" class="is-required-ja">現在のパスワード</label>
                                        <input
                                            v-model="current_password"
                                            type="password"
                                            id="current_password"
                                            class="form-control"
                                            :class="{ 'is-invalid' : errors.current_password }"
                                            placeholder="パスワード">

                                        <div v-if="errors.current_password" class="invalid-feedback d-block">
                                            {{ errors.current_password[0] }}
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div class="row">
                                <div class="col-12">
                                    <div class="mb-3 mb-0-sm">
                                        <label for="new_password" class="is-required-ja">新規パスワード</label>
                                        <input
                                            v-model="new_password"
                                            type="password"
                                            id="new_password"
                                            class="form-control"
                                            :class="{ 'is-invalid' : errors.new_password }"
                                            placeholder="新規パスワード">

                                        <div v-if="errors.new_password" class="invalid-feedback d-block">
                                            {{ errors.new_password[0] }}
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div class="row">
                                <div class="col-12">
                                    <div class="mb-3 mb-0-sm">
                                        <label for="new_password" class="is-required-ja">新規パスワード（確認）</label>
                                        <input
                                            v-model="new_password_confirm"
                                            type="password"
                                            id="new_password_confirm"
                                            class="form-control"
                                            :class="{ 'is-invalid' : errors.new_password_confirm }"
                                            placeholder="新規パスワードの再入力">

                                        <div v-if="errors.new_password_confirm" class="invalid-feedback d-block">
                                            {{ errors.new_password_confirm[0] }}
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div class="row">
                                <div class="col">
                                    <hr>
                                    <ul class="mb-0">
                                        <li class="mb-2">
                                            <span class="small">パスワードはアルファベット（小・大文字を両方含む）と数字の組み合わせ8～32文字で設定してください</span>
                                        </li>
                                        <li class="mb-2">
                                            <span class="small">パスワードとして使用可能な記号は</span>
                                            <span class="">&nbsp;!&nbsp;$&nbsp;%&nbsp;+&nbsp;/&nbsp;=&nbsp;?&nbsp;[&nbsp;]&nbsp;@&nbsp;</span>
                                            <span class="small">です</span>
                                        </li>
                                    </ul>
                                    <hr>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="d-flex justify-content-center">
                    <a
                        v-if="completed && this.$store.state.configs.subscription != 1"
                        href="/home"
                        class="btn btn-yokumiru-gray">
                        ダッシュボードを表示
                    </a>
                    <button
                        v-else-if="!completed"
                        class="btn btn-yokumiru-orange"
                        :disabled="inProgress"
                        @click="update">
                        設定を更新
                    </button>
                </div>
            </div>
        </div>

        <user-coupons-notification-modal
            :user="dataUser"
            :user-coupons="newUserCoupons"
            is-first-setup>
        </user-coupons-notification-modal>

        <how-to-use-coupon-modal/>
    </div>
</template>

<script>
    import YokumiruHelper from '../../YokumiruHelper'
    import constants from '../../constants'
    import moment from 'moment-timezone'
    import { mapMutations } from 'vuex'

    export default {
        props: {
            dataUser: {
                type: Object,
                default: {},
            },
        },

        data: function() {
            return {
                helper: YokumiruHelper,
                user: null,
                birth_year: null,
                birth_month: null,
                birth_day: null,
                yearBase: 1899,
                yearTo: moment().year(),
                errors: {},
                inProgress: false,
                current_password:'',
                new_password:'',
                new_password_confirm:'',
                completed: false,
                timezones: [],
                newUserCoupons: [],
            };
        },

        computed: {
            /**
             * キャンペーン
             *
             * @return {array}
             */
            campaigns: function () {
                return this.user.user_coupons.map(user_coupon => user_coupon.campaign)
            },

            /**
             * キャンペーン（重複除外）
             *
             * @return {array}
             */
            uniqueCampaigns: function () {
                const camps = []
                this.campaigns.forEach((campaign) => {
                    const added = !!camps.find(camp => camp.id === campaign.id)
                    if (!added) camps.push(campaign)
                })
                return camps
            },

            rangeYear: function () {
                return this.yearTo - this.yearBase
            },

            rangeDate: function () {
                const year = this.birth_year ? this.birth_year.toString() : '1900'
                const month = this.birth_month ? this.birth_month.toString().padStart(2, '0') : '01'

                return moment(`${year}-${month}-01`).endOf('month').date()
            },
        },

        created: async function () {
            this.user = { ...this.dataUser }

            if (this.user.is_admin_registration) {
                if (this.user.birthday) {
                    this.birth_year = Number(this.user.birthday.slice(0,4))
                    this.birth_month = Number(this.user.birthday.slice(5,7))
                    this.birth_day = Number(this.user.birthday.slice(8,10))
                }
            }
            else {
                this.user.sex = null
            }

            if (this.$store.state.configs.timezone == 1) {
                await this.fetchTimezones()
                this.syncDeviceTimezone()
            }
        },

        mounted: function () {
            // メールアドレス認証結果のアラート
            if (this.$route.query.verified === '1') {
                bus.$emit('alert-success', 'メールアドレスを認証しました。')
            }

            // サブスクリプション開始後アラート
            if (this.$store.state.userMode.isAgreedTerms) {
                this.setIsAgreedTerms(false)
                bus.$emit('alert-info', '利用規約に同意しました。')
            }
        },

        methods: {
            ...mapMutations({
                setIsAgreedTerms: 'userMode/setIsAgreedTerms',
                setIsResetPassword: 'userMode/setIsResetPassword',
            }),

            syncDeviceTimezone: function () {
                if (this.user.is_device_timezone == 1) {
                    this.prevTimezone = this.user.timezone
                    const browserZone = moment.tz.guess()

                    this.timezones.forEach((timezone) => {
                        if (timezone.key === browserZone) {
                            this.user.timezone = browserZone
                        }
                    })
                }
                else if (this.prevTimezone) {
                    this.user.timezone = this.prevTimezone
                }
            },

            fetchTimezones: function () {
                return axios.get(constants.user.profile.endpoint.timezone)
                    .then(({data}) => {
                        const momentTimezones = moment.tz.names()
                        this.timezones = data.data.filter((d) => momentTimezones.includes(d.key))
                    })

                const browserZone = moment.tz.guess()

                this.timezones.forEach((timezone) => {
                    if (timezone.key === browserZone) {
                        this.user.timezone = browserZone
                    }
                })
            },

            /**
             * 初回ログイン情報更新
             */
            update: async function() {
                if (this.inProgress) return
                this.inProgress = true

                let birthday = null

                if (this.birth_year && this.birth_month && this.birth_day) {
                    birthday = this.birth_year.toString() + '-' +
                        this.birth_month.toString().padStart(2, '0') + '-' +
                        this.birth_day.toString().padStart(2, '0')
                }

                const data = {
                    birthday: birthday,
                    sex: this.user.sex,
                    height: this.user.height,
                    weight: this.user.weight,
                    blood: this.user.blood,
                    current_password: this.current_password,
                    new_password: this.new_password,
                    new_password_confirm: this.new_password_confirm,
                }

                if (this.$store.state.configs.timezone == 1) {
                    data['timezone'] = this.user.timezone
                    data['is_device_timezone'] = this.user.is_device_timezone
                }

                await axios.put(`${constants.user.me.endpoint.base}/first`, data)
                    .then(() => {
                        this.setIsResetPassword(true)
                        if (this.$store.state.configs.subscription == 1) {
                            window.location.href = '/subscriptions/setup'
                        }
                        else {
                            window.location.href = '/home'
                        }
                    })
                    .catch(({response}) => {
                        if (response.hasOwnProperty('data') &&
                            response.data.hasOwnProperty('errors')) {
                            this.errors = response.data.errors
                            bus.$emit('alert-danger')
                        }
                        else {
                            bus.$emit('alert-danger', 'システムエラーが発生しました。')
                        }

                        this.inProgress = false
                    })
            },
        },
    }
</script>

<style scoped lang="scss">
.card {
    box-shadow: 0px 4px 12px 0px #00000026;
    border-radius: 0;
}

.userAuthHeader {
    margin-bottom: 12px;
    font-size: 18px;
    font-weight: bold;
    color: #7D868D;
}
</style>
